export const environment = {
  production: true,
  donationProvider: 'zeffy',
  zeffyDefaultDonationUrl:
    'https://www.zeffy.com/en-US/fundraising/donate-to-make-a-difference-11620',
  zeffyPopupDonationUrl:
    'https://www.zeffy.com/en-US/donation-form/new-bus-for-the-hogar-de-ninos',
  recaptchaSiteKey: '6LdxaHwtAAAAACRUdi-dEbLuSFx2OChKXp6VTFSI',
  apiBaseUrl: 'https://dev.api.crezcofoundation.org',
  controller: 'donations/commands',
  stripePublicKey:
    'pk_test_51Rpbjn4bv3RQlmHqg6RWfTS97PVznZzwTZdrzxyonQxWB3yoMm8H0CZCVaHdgLzOrh6aXOai3NDdpJHQTqf1VZMW00dk1OTmkq',
  signalRNegotiateUrl:
    'https://dev.api.crezcofoundation.org/api/signalr/negotiate',

  cardFees: {
    US: {
      percent: 2.2,
      fixedMinor: 30,
    },
    INTERNATIONAL: {
      percent: 3.2,
      fixedMinor: 30,
    },
    AMEX: {
      percent: 3.5,
      fixedMinor: 0,
    },
  },
  stripeProductFees: {
    oneTimeInvoicePercent: 0,
    recurringBillingPercent: 0.7,
  },
};
